import { useState } from 'react'

import './footer.sass'

const Footer = () => {
    const [open, setOpen] = useState(false)
    const openMention = () => {
        setOpen(!open)
    }
    const [collapse, setCollapse] = useState([false, false, false])
    const toggle = (index) => {
        setCollapse((prevState) => {
            const updatedStates = [...prevState]
            updatedStates[index] =!updatedStates[index]
            return updatedStates
        })
        console.log(collapse);
    }
    return (
        <div className='footer'>
            <div className='footer__rod'></div>
            <button className='footer__btn' onClick={openMention}>Mentions légale</button>
            {/* {open && (
                <div className='footer__mention'>
                    <div className='footer__mention__content'>
                        <div className='footer__mention__content__header'>
                            <h1 className='footer__mention__content__header__title'>Mentions légales</h1>
                            <button className='footer__mention__content__header__btn' onClick={openMention} aria-label="bouton fermer" ><i className='fa-solid fa-xmark fa-2xl'></i></button>
                        </div>
                        <div className='footer__mention__content__body'>
                            <p className='footer__mention__content__body'><strong>SCS Informatique</strong></p>
                            <p className='footer__mention__content__body'>Capital social : 7 500€</p>
                            <p className='footer__mention__content__body'>RCS de Grenoble : 451 468 003</p>
                            <p className='footer__mention__content__body'>Numéro de TVA : FR 05451468003</p>
                            <p className='footer__mention__content__body'>Siège social : 250 Rue des Tamagnards, ZAE les Geymonds, 38250 Villard de lans, France</p>
                            <div className={collapse[0] ? 'footer__mention__content__body__host actived' : 'footer__mention__content__body__host'} onClick={() => toggle(0)}>
                                <h3>Hébergeur</h3>
                                <i className={collapse[0] ? 'fa-solid fa-angle-up active' : 'fa-solid fa-angle-up inactive'}></i>
                            </div>
                            <div className={collapse[0] ? 'footer__mention__content__body__host__infos open' : 'footer__mention__content__body__host close'}>
                                <p>Hébergeur du site : <a href='https://www.ovhcloud.com/fr/'>OVHCloud</a></p>
                                <p>Siège social : 2 rue Kellermann, 59100 Roubaix, France</p>
                                <p>Numéros d'appel (standard du siège social) : Téléphone : 08 20 32 03 63 (0.118 €/mn) – Fax : 03 20 20 09 58</p>
                            </div>
                            <div className={collapse[1] ? 'footer__mention__content__body__host actived' : 'footer__mention__content__body__host'} onClick={() => toggle(1)}>
                                <h3>Propriété intellectuelle</h3>
                                <i className={collapse[1] ? 'fa-solid fa-angle-up active' : 'fa-solid fa-angle-up inactive'}></i>
                            </div>
                            <div className={collapse[1] ? 'footer__mention__content__body__host__infos open' : 'footer__mention__content__body__host close'}>
                                <p>Nous vous informons que toute reproduction ou représentation totale ou partielle, par quelque procédé que ce soit, de ce site, des logos, des images pouvant y figurer est interdite sans l'autorisation expresse de SCS Informatique et constituerait une contrefaçon sanctionnée par les articles L 335-2 et suivants du Code de la propriété intellectuelle.</p>
                            </div>
                            <div className={collapse[2] ? 'footer__mention__content__body__host actived' : 'footer__mention__content__body__host'} onClick={() => toggle(2)}>
                                <h3>Protection des données personnelles</h3>
                                <i className={collapse[2] ? 'fa-solid fa-angle-up active' : 'fa-solid fa-angle-up inactive'}></i>
                            </div>
                            <div className={collapse[2] ? 'footer__mention__content__body__host__infos open' : 'footer__mention__content__body__host close'}>
                                <p>Le site <strong>scsinformatique.com</strong> ne conserve, ne stocke aucune donnée personnelle concernant ses visiteurs.</p>
                            </div>

                        </div>
                    </div>
                </div>

            )} */}
            <p className='footer__para'>SCS Informatique © 2004-2024</p>
        </div>
    )
}

export default Footer